import { useMemo } from 'react';
import { CElement, IConfigComponent, COrganization, CRole } from '@ts/ui-models';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { IRouterProps } from '@interfaces/App.interface';
import {
  generateGlobalColumns,
  generateBasicColumn,
  generateEntityColumn,
  TInheritedProps,
  IDataGridConfig,
  Link,
} from '@ts/storybook';
import Users, { defaultConfigComponent as UConfigComponent } from '@pages/DataBase/Users/Users';
import actStore from '@flux/actions/actStore';

interface IRolesProps extends IRouterProps {
  configComponent?: IConfigComponent;
  inheritedProps?: TInheritedProps<false>;
  title?: string;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'roles',
  aclId: 'taRole',
  entity: 'role',
  fetchURL: '/api/roles',
  crudURL: '/api/role',
  mainClass: CRole,
};

const Roles = (props: IRolesProps) => {
  const { configComponent = defaultConfigComponent, inheritedProps } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };
  const getColumns = useMemo((): GridColDef<any>[] => {
    const mixProps = { ...props, configComponent, isFilterable: true };
    const globalCells = generateGlobalColumns(mixProps);
    return [
      globalCells.id(undefined, undefined, { filtrable: false }),
      generateEntityColumn({ field: 'organization' }, { field: 'organization', mainClass: COrganization }, { inheritedProps }),
      globalCells.name(undefined, undefined, { filtrable: false }),
      {
        field: 'users',
        headerName: 'Users',
        filterable: false,
        renderCell: (params: GridRenderCellParams<any, CElement, any>) => {
          if (params.row.xUsersRoles.length > 0) {
            return (
              <Link
                onClick={() => {
                  actStore.setActionTableV3({
                    action: 'openModalExtraComp',
                    component: Users,
                    propsComponent: {
                      title: 'Users',
                      configComponent: { ...UConfigComponent, filtersFetchData: { role: { id: params.row.logicalId } } },
                    },
                    row: params.row,
                  });
                }}
              >
                {params.row.xUsersRoles.length}
              </Link>
            );
          }
          return 0;
        },
      },
      generateBasicColumn({ field: 'description' }, { field: 'description' }),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      customDeleteModal={{ message: 'This will also erase associations related to the item' }}
      inheritedProps={props.inheritedProps}
      enabledFilters
    />
  );
};

export default Roles;
